import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateUpdateEmailUser = {
  updateEmailUser: { data: null, loading: false, error: null },
};

export const updateEmailUser = createAsyncThunk('user/updateEmailUser', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .put(
      `${process.env.REACT_APP_SERVER_API}/users/${data.id}/email`,
      { email: data.email },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
      },
    )
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerUpdateEmailUser = {
  [updateEmailUser.pending]: (state) => {
    state.updateEmailUser.loading = true;
    state.updateEmailUser.error = null;
  },
  [updateEmailUser.fulfilled]: (state, action) => {
    state.updateEmailUser.loading = false;
    state.updateEmailUser.data = true;
    state.updateEmailUser.error = null;
  },
  [updateEmailUser.rejected]: (state, action) => {
    state.updateEmailUser.loading = false;
    state.updateEmailUser.error = action.payload;
  },
};
